/** Pathnames that use the CRM shell (Stream sidebar + auth gate). */
export const CRM_PATH_PREFIXES = [
  '/dashboard',
  '/message',
  '/messages',
  '/account',
  '/pets',
  '/setup',
]

export function isCrmPath(pathname = '') {
  const p = String(pathname || '')
  return CRM_PATH_PREFIXES.some(
    (prefix) => p === prefix || p.startsWith(`${prefix}/`),
  )
}
